const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '实时追踪热点',
    desc: '全网黑料视频与吃瓜内容7×24小时不间断更新，绝不错过任何热门话题。',
  },
  {
    id: 2,
    icon: 'ri-movie-line',
    title: '海量高清内容',
    desc: '覆盖明星八卦、综艺揭秘、影视动态等多分区，精彩视频一网打尽。',
  },
  {
    id: 3,
    icon: 'ri-speed-up-line',
    title: '流畅不卡顿',
    desc: '采用先进CDN加速技术，确保高清视频播放流畅无卡顿，观看体验一流。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '绿色安全的浏览环境，无弹窗广告骚扰，专注内容观看体验。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            为什么数百万用户选择在51黑料在线观看最新吃瓜视频
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f) => (
            <div
              key={f.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center transition-all hover:-translate-y-1"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-accent-100 flex items-center justify-center">
                <i className={`${f.icon} text-accent-600 text-2xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}